















import { Component, Vue } from 'vue-property-decorator';
import Chat from './Chat.vue';
import { mapGetters } from 'vuex';

@Component({
  components: { Chat },
  computed: mapGetters({
    unreadMessagesCount: 'chat/unreadMessagesCount'
  }),
})
export default class UserChat extends Vue {
  chatOpened: boolean = false;

  hideChat() {
    this.chatOpened = false;
  }
}
